import React from "react";
import {Badge} from "reactstrap";

const MutualExclusivityType = ({type}) => {
    if (type === "Mutual Exclusivity, 1st match only") {
        return <Badge color="success" className="mr-1 mb-1 badge-pill">1st match only</Badge>
    }else if (type === "Mutual Exclusivity, always") {
        return <Badge color="info" className="mr-1 mb-1 badge-pill">always</Badge>
    }

    return type;
};

export default MutualExclusivityType;
